import React from 'react';
import Entity from '../Entity';

class Story extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      story: props.story,
    }
  }

  captionWithEntity(caption, entity) {
    let parts = caption.split(entity.name);
    let result = [];
    let key = 0;

    parts.forEach((part, index) => {
      if (index !== 0) {
        result.push(<Entity entity={entity} key={key}/>);
        key++;
      }

      let innerHtml = {__html: part};
      result.push(<span dangerouslySetInnerHTML={innerHtml} key={key}></span>);
      key++;
    });

    return result;
  }

  formatDate(date) {
    var formatDateElement = function(element) {
      if (element < 10) {
        return '0' + element;
      }
      return element;
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    var hours = formatDateElement(d.getHours());
    var minutes = formatDateElement(d.getMinutes());

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('-') + " " + hours + ":" + minutes;
  }
}

export default Story;